export default __webpack_public_path__ + "static/media/Gps_fixed.76a3db28.svg";